let List = () => import (/* webpackChunkName: "cadastros/veiculos" */'../pages/cadastros/Veiculos.vue');
let ListCancelados = () => import (/* webpackChunkName: "cadastros/veiculos-cancelados" */'../pages/cadastros/VeiculosCancelados');

export const Veiculo = {
    List, ListCancelados
};
